import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';

interface CustomSearchCustomerCookReviewsSlice {
    [x: string]: string | undefined;
    id: any;
    customerName: any;
    customerRating: any;
    customerReviewComment: string;
    averageRatingPerCook: any
}

interface CustomSearchCustomerCookReviewsState {
    data: CustomSearchCustomerCookReviewsSlice[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_FOOD_ORDER_PORT;
const URL = import.meta.env.VITE_API_FOOD_ORDER_URL;

export const customSearchCustomerCookReviews = createAsyncThunk<
    CustomSearchCustomerCookReviewsSlice[],
    { cookProfileId: any },
    { rejectValue: string }
>(
    'CustomSearchCustomerCookReviews/customSearchCustomerCookReviews',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>(
                'custom_search_customer_cook_review',
                PORT,
                URL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

const initialState: CustomSearchCustomerCookReviewsState = {
    data: [],
    loading: false,
    error: null,
};

export const CustomSearchCustomerCookReviewsSlice = createSlice({
    name: 'CustomSearchCustomerCookReviews',
    initialState,
    reducers: {
        clear: (state) => {
            state.data = [];
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(customSearchCustomerCookReviews.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                customSearchCustomerCookReviews.fulfilled,
                (state, action: PayloadAction<CustomSearchCustomerCookReviewsSlice[]>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(customSearchCustomerCookReviews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch food items';
            });
    },
});

export default CustomSearchCustomerCookReviewsSlice.reducer;
